import React from 'react';
import { styles } from './item-list-styles';

interface Props {
  pageSize: number;
}

const EmptyLine: React.FC<Props> = (props: Props): JSX.Element => {
  const { pageSize } = props;
  const classes = styles({ pageSize });

  return <div className={classes.lineItem} data-testid='empty-line' />;
};

export default EmptyLine;
